import { useAnalytics } from "@codat/analytics";
import { Button, SquareNewWindowIcon, Typography } from "@codat/orchard-ui";
import React, { FC } from "react";

import { CreateApiKeyButton } from "../CreateApiKeyButton";
import styles from "./Header.module.scss";

interface HeaderProps {
  numberOfKeys: number | undefined;
  onCreateClick: () => void;
}

export const Header: FC<HeaderProps> = ({ numberOfKeys, onCreateClick }) => {
  const { sendEvent } = useAnalytics();

  return (
    <header className={styles.header}>
      <div className={styles.row}>
        <Typography variant="heading_xxl" as="h1">
          API keys
        </Typography>
        <div className={styles.actions}>
          <Button
            variant="secondary"
            color="interface"
            data-testid="header-cta"
            href="https://docs.codat.io/using-the-api/authentication"
            target="_blank"
            onClick={() => {
              sendEvent("Documentation Link - Click");
            }}
          >
            Authenticating Codat&apos;s API
            <SquareNewWindowIcon className={styles.iconRight} />
          </Button>
          <CreateApiKeyButton
            onClick={onCreateClick}
            isLimit={numberOfKeys === 10}
            isLoading={numberOfKeys === undefined}
          />
        </div>
      </div>
      <Typography variant="body_lg" as="h2" className={styles.pageSubtitle}>
        {numberOfKeys ?? "X"}/10 API keys
      </Typography>
    </header>
  );
};
